var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxRoundedWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#f1f3f4",
    d: "M40 1.35c21.487 0 38.906 17.419 38.906 38.906S61.487 79.162 40 79.162 1.094 61.743 1.094 40.256 18.513 1.35 40 1.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000006",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 50,
    strokeWidth: 2,
    d: "M40 1.35c21.487 0 38.906 17.419 38.906 38.906S61.487 79.162 40 79.162 1.094 61.743 1.094 40.256 18.513 1.35 40 1.35z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    width: 40,
    height: 22,
    transform: "translate(20 30)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAWCAYAAACyjt6wAAAAAXNSR0IArs4c6QAAAd1JREFUSA3Flr8rRXEYxv0oYiFlkViMlM2olNVoYLCyKBt/gDJINjYlkmRgFUkWm0gWk7CYLAYlPs/l0XX63nOP7z3ufevpOff9vu/zPvfc03tPXd1XNEIbYPL7cy1phuHHoNUmmrjYAR/gHUyDWsUcg+VDOAEFkwdFSR/Okqt2LDDQ881HMjEFdOecNM/rsEqxxBzPNb+RG/f8CS6U8KF50QX/xPXorgbmystYcqYSIZPL5CWUdzQguAZ8M8yv5EZKDRvlQAUuNksoT5PaGtuBOS/khkFqyL0Kbc68SU7ClYa2xh6wrlkzh7KKqzBkUutIA2KjmcZDYFPmZ3IDfxUdpEGNFjFrQIxJ7TTtNuuYH8j1g6jQt3oCFjNrP/1s+gzKbdScBXRkri9Df2qJBCRkc2bdDQ0uF+0UXAD3me/IdZdrznreS6EELW7W4DSTnZxfB/qUy80cWoWQ4C2wOfMlORlJhupvgOvMV+RC9cn+qM9pd6SrSLGH65g7XiQRf9lBa9ozVeqZPaUv7XGIdxTo1KBz4J/NfE/uMZD/9X7HeVWi1F6zWXPs3szlS7SgIgM2k+RdzmKWei7mLCID+yBpbotcHv/dnlMRJ99O8n77qcicm2VyHayA3F7NPgFdA8//FmRtHQAAAABJRU5ErkJggg=="
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxRoundedWhite);
export default __webpack_public_path__ + "static/media/checkbox_rounded_white.2a5084fe6cc1330519f9998cca95d8e6.svg";
export { ForwardRef as ReactComponent };